import React from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { PrimaryButton } from 'shared/components/button'
import CheckboxRhf from 'shared/components/checkbox-rhf'
import ErrorMessageRhf from 'shared/components/error-message-rhf'
import FormInputRhf from 'shared/components/form-input-rhf'
import { AuthRegularCardLayout } from 'modules/authentication/components/auth-regular-card-layout'
import useLoginForm from 'modules/authentication/login/hooks/use-login-form'

export const LoginForm = ({ hasCustomDomain }: { hasCustomDomain?: boolean }) => {
  const { t } = useTranslation()

  const { formRef, handleSubmit, control, setValue, errors, isLoading, onSubmit } = useLoginForm({
    hasCustomDomain,
  })

  return (
    <AuthRegularCardLayout title={t('security.login.title')}>
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-5">
        <FormInputRhf
          type="email"
          name="email"
          className="flex-auto text-[1.1rem] font-normal"
          label={t('security.login.username')}
          control={control}
          setValue={setValue}
          maxLength={180}
          error={errors.email?.message}
          rules={{ required: t('login.validation.email') }}
          autoComplete="username"
          autoCapitalize="none"
          spellCheck={false}
        />
        <FormInputRhf
          type="password"
          name="password"
          setValue={setValue}
          className="flex-auto text-[1.1rem] font-normal"
          label={t('security.login.password')}
          control={control}
          maxLength={180}
          error={errors.password?.message}
          rules={{ required: t('login.validation.password') }}
          autoComplete="current-password"
          autoCapitalize="none"
          spellCheck={false}
        />
        <ErrorMessageRhf errors={errors} fieldName="root" />

        <div className="flex flex-col items-center justify-between gap-3 sm:flex-row sm:items-start">
          <CheckboxRhf
            name="rememberMe"
            setValue={setValue}
            control={control}
            label={t('security.login.stay_connected')}
          />
          <Link className="leading-5 text-brand-primary" href={'/restore-password'}>
            {t('login.forgetpassword')}
          </Link>
        </div>
        <PrimaryButton isLoading={isLoading} type="submit" className="text-xl">
          {t('security.login.submit')}
        </PrimaryButton>
        {!hasCustomDomain && (
          <>
            <p className="text-text-primary/50">{t('user.login.text.dont_have_account')}</p>
            <Link className="text-brand-primary" href={'/register'}>
              {t('user.login.create_account_link')}
            </Link>
          </>
        )}
      </form>
    </AuthRegularCardLayout>
  )
}
